<template>
  <keep-alive>
    <layout-mobile v-if="isMobileLayout">
      <leads-page-content/>
    </layout-mobile>
    <layout-page v-else>
      <leads-page-content/>
    </layout-page>
  </keep-alive>
</template>

<script>
import LeadsPageContent from "./components/LeadsPageContent.vue";

export default {
  name: "LeadsPage",
  components: {
    LeadsPageContent,
  },
  metaInfo: {
    title: "Leads"
  },
  computed: {
    isMobileLayout() {
      return this.$store.state.isMobile
    },
  },
}
</script>

<style scoped lang="scss">

</style>
